const resourceManagementComponentLoaders = Object.freeze({
  'resource-management.configuration-workspace': async () => {
    const module = await import('./resource-configuration-workspace-component.js');
    return module.ResourceConfigurationWorkspaceComponent;
  },
});

export default resourceManagementComponentLoaders;
